export enum MessageType {
  PLANE = 0,
  SYSTEM = 1,
  ADMIN = 2,
}

export enum SystemMessageType {
  CREATE_ROOM,
  CLEAN_ROOM,
  GIFT_BULLET,
  JOIN_USER,
  PICK,
  PICK_RESULT,
  START_PROJECT,
  WIN_PROJECT,
  DEFEAT_PROJECT,
  CHANGE_GAME_TYPE,
  ROUND_RESULT,
  SNIPER_MESSAGE,
  CHANGE_ROOM_TYPE,
  RECOMMEND_ROOM,
  USE_CLEAR_HISTORY_ITEM,
  KICK_USER,
  FREEZE_USER,
  APPOINT_MANAGER,
  DISAPPOINT_MANAGER,
  FREEZE_ALL,
  UNFREEZE_ALL,
  RENAME_ROOM,
}

export interface UserDetail {
  id: string;
  nickname: string;
  level: number;
  hasThumbnail: boolean;
  todayComment: string;
  gasMask: boolean;
  familyNickname: string;
  maxStreak: number;
  decorationItem: boolean;
  sniperItem: boolean;
}

export interface Message {
  user: string;
  messageType: MessageType;
  contents: string | {
    systemMessageType: SystemMessageType;
    pick?: string;
  };
}